import { useCallback, useEffect, useRef, useState } from 'react'

const DEFAULT_INTERVAL = 600
const CEILING = 99
const SLOW_DOWN_AT = 90

const useFakeProgress = (intervalMs = DEFAULT_INTERVAL) => {
  const [percentage, setPercentage] = useState(0)
  const timer = useRef(null)

  const stop = useCallback(() => {
    if (timer.current) {
      clearInterval(timer.current)
      timer.current = null
    }
  }, [])

  const start = useCallback(() => {
    let value = 0

    stop()
    setPercentage(0)

    timer.current = setInterval(() => {
      if (value >= CEILING) {
        return stop()
      }

      value += value >= SLOW_DOWN_AT ? 1 : 10
      setPercentage(value)
    }, intervalMs)
  }, [intervalMs, stop])

  const complete = useCallback(() => {
    stop()
    setPercentage(100)
  }, [stop])

  const reset = useCallback(() => {
    stop()
    setPercentage(0)
  }, [stop])

  useEffect(() => stop, [stop])

  return { percentage, start, stop, complete, reset }
}

export default useFakeProgress
